import { useEffect, useRef, useState } from "react";
import { Link, useParams } from "react-router-dom";
import Layout from "@/components/layout/Layout";
import { useReorder } from "@/components/track/useReorder";
import { btnPrimary } from "@/components/simple/product/Fields";

/** `/r/:token` from the receipt (7.10): the same lines again, straight into Stripe. */
export default function Reorder() {
    const { token } = useParams();
    const { reorder, busy } = useReorder();
    const [failed, setFailed] = useState(false);
    const started = useRef(false);

    const go = async () => {
        setFailed(false);
        const ok = await reorder({ token });
        if (!ok) setFailed(true);
    };
    useEffect(() => { if (!started.current) { started.current = true; go(); } }, []); // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <Layout title="Reorder">
            <section className="px-3 py-4 text-ink" data-testid="reorder-page">
                <h1 className="text-[28px] font-semibold leading-tight">{busy ? "Setting up your reorder…" : "Reorder"}</h1>
                <p className="mt-2 text-[16px] text-muted-ink">Same lines, today's prices. Quantities can be changed on the payment page.</p>
                {!busy && (
                    <>
                        <Link to="/track" className={`${btnPrimary} mt-4`} data-testid="reorder-track">Track an order</Link>
                        <button type="button" onClick={go} className="mt-3 flex min-h-[44px] items-center text-[16px] underline" data-testid="reorder-retry">Try again</button>
                    </>
                )}
                {failed && <p className="mt-3 text-[16px]" style={{ color: "var(--error)" }} data-testid="reorder-failed">That reorder link isn't valid any more.</p>}
            </section>
        </Layout>
    );
}
